<template>
  <div>
    <div style="margin-top: 200px" v-if="fixed"></div>
    <div class="footer-box" :class="fixed ? ' fixed' : ''">
      <div class="footer-content">
        <div class="left-logo">
          <!--<a href="http://bszs.conac.cn/sitename?method=show&id=09D70AB4617D5140E053012819ACEA16" target="_blank"><img
              src="../../assets/footer1.jpg" alt="" /></a>-->
        </div>
        <div class="middle-text" style="width: 100%">
          <div class="footer-left">
            <div>承办单位：咸宁市政务服务和大数据管理局</div>
            <div>办公室地址：咸宁市高新区旗鼓大道101号（ 咸宁市民之家 ）</div>
            <div>Copyright 2022 www.xianning.gov.cn ALL Rights Reserved.</div>
            <div>
              <span
                ><a
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  target="_blank"
                  >鄂ICP备05011845号</a
                >
              </span>
              <span>
                <a
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=421 2020 2000220"
                  target="_blank"
                >
                  鄂公网安备421202000220号</a
                ></span
              >
              <span>政府网站标识码：4213000003</span>
              <span
                ><a
                  href="https://web.umeng.com/main.php?c=site&a=frame&siteid=5353457#!/1618813509766/site/overview/1/5353457/2021-04-19/2021-04-19"
                  target="_blank"
                  ><img src="../../assets/footer2.jpg" alt="" /></a
              ></span>
            </div>
          </div>
          <div class="footer-app">
            <div class="img-code">
              <img
                src="../../assets/app_download_new.jpg"
                alt=""
                width="125px"
              />
              鄂汇办APP
            </div>
            <div class="img-code">
              <img
                src="../../views/mainPage/homeGuide/homeImg/ercode.png"
                alt=""
                width="125px"
              />
              咸宁“码”上办
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
.footer-box {
  width: 100%;
  background: #0e72ec;
  margin-top: 15px;
}

.fixed {
  position: fixed;
  bottom: 0;
}

.footer-content {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 24px 0px;
}

.footer-content::after {
  content: "\20";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  overflow: hidden;
}

.footer-content > div {
  float: left;
}

.left-logo {
  width: 10%;
}

.middle-text {
  font-size: 14px;
  color: #fff;
  width: 65%;
  text-align: center;
}

.middle-text > div {
  margin-bottom: 10px;
}

.middle-text span {
  margin-right: 20px;
}

.footer-content img {
  cursor: pointer;
}

a {
  color: #fff;
  text-decoration: none;
}

a:hover {
  color: #46a8fe;
}

@media screen and (max-width: 1200px) {
  .footer-content {
    width: 94%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 21px 0px;
  }
}

@media screen and (max-width: 1028px) {
  .middle-text {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 767px) {
  .middle-text {
    width: 85%;
    text-align: left;
  }

  .left-logo {
    margin-right: 4%;
  }

  .left-logo img {
    width: 35px;
    height: 45px;
  }

  .middle-text span {
    margin-right: 13px;
  }
}
.footer-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  float: left;
  margin-top: 18px;
  margin-left: 25px;
}
.footer-left > div {
  margin-bottom: 14px;
}

.footer-app {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.img-code > img {
  margin-bottom: 7px;
}
.img-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 59px;
  margin-left: 16px;
}
</style>
